import { useState } from "react";
import "../styles/event_details.css";

export default function ScrollableImageList({ images = [] }) {
  const [current, setCurrent] = useState(null);

  const next = () => setCurrent((current + 1) % images.length);
  const prev = () => setCurrent((current - 1 + images.length) % images.length);
  const close = () => setCurrent(null);

  return (
    <>
      <div className="scroll-container">
        {images.map((src, i) => (
          <img
            key={i}
            alt={src}
            src={src}
            className="thumb"
            onClick={() => setCurrent(i)}
          />
        ))}
      </div>

      {current !== null && (
        <div className="fullscreen">
          <button className="nav left" onClick={prev}>
            ‹
          </button>
          <img
            alt={images[current]}
            src={images[current]}
            className="full-image"
          />
          <button className="nav right" onClick={next}>
            ›
          </button>
          <button className="close" onClick={close}>
            ×
          </button>
        </div>
      )}
    </>
  );
}
